<template>
  <div>
    
    <div class="event-pic">
      <swiper
        ref="mySwiper"
        :options="swiperOptions"
        class="swiper-wrappe carousel"
      >
        <swiper-slide
            class="swiper-slide"
            v-for="(b, i) in picDataSource"
            :key="i"
          >
            <img :src="b.cmsCover_url" alt="" @click="toPicDetail(b)"/>
        </swiper-slide>

        <!-- 分页器 -->
        <div
          v-show="oldEventPic && oldEventPic.length > 1"
          class="swiper-pagination swiper-pagination-white"
          slot="pagination"
        ></div>
        <!-- 左右箭头 -->
        <div
          v-show="oldEventPic && oldEventPic.length > 1"
          class="swiper-button-prev swiper-button-white"
          slot="button-prev"
        ></div>
        <div
          v-show="oldEventPic && oldEventPic.length > 1"
          class="swiper-button-next swiper-button-white"
          slot="button-next"
        ></div>
      </swiper>
      <router-link
      class="see-more"
      slot="tabBarExtraContent"
      :to="{ path: '/cms/pic' }"
      >查看更多>></router-link
    >
    </div>
    <br />
    <div class="event-video">
      
      <br />
      <a-list
        :grid="{ gutter: _isMobile() ? 12 : 24, lg: 4, md: 4, sm: 2, xs: 2 }"
        :dataSource="videoDataSource"
      >
        <a-list-item
          class="animate__animated animate__fadeIn"
          slot="renderItem"
          slot-scope="item"
        >
          <div class="img-zoom" @click="toVideoDetail(item)">
            <img class="cover" :src="item.cmsCover_url" alt="" />
          </div>
          <!-- <h3 class="title">{{ item.cmsTitile }}</h3> -->
        </a-list-item>
      </a-list>
      <router-link
        class="see-more"
        slot="tabBarExtraContent"
        :to="{ path: '/cms/video' }"
        >查看更多>></router-link
      >
      <br>
    </div>
    <a-modal
      :width="800"
      :visible="videoVisible"
      :maskClosable="false"
      :title="currentVideo.cmsTitile"
      :destroyOnClose="true"
      @cancel="videoVisible = false"
      :footer="null"
    >
      <video
        style="width: 100%"
        controls
        controlsList='nodownload noremote footbar'
        oncontextmenu="return false;"
        autoplay
        :src="currentVideo.extraFile_url"
      ></video>
    </a-modal>
    <LightBox :showLightBox="false" ref="lightbox" :showCaption="true" :media="lightBoxMedia"></LightBox>
  </div>
</template>

<script>
import { getAction } from "@/api/manage";
import { mixinDevice } from "@/utils/mixin.js";
import "@/assets/less/animation.css";
import LightBox from 'vue-image-lightbox'
require('vue-image-lightbox/dist/vue-image-lightbox.min.css')
export default {
  mixins: [mixinDevice],
  components:{
    LightBox
  },
  data() {
    return {
      tenantConfig: {},
      videoDataSource: [],
      picDataSource:[],
      videoVisible: false,
      currentVideo: {},
      swiperOptions: {
        speed: 800,
        effect: this._isMobile()?"fade":"coverflow", //"fade"（淡入）、"cube"（方块）、"coverflow"（3d流）、"flip"（3d翻转）
        slidesPerView: 3,
        centeredSlides: true,
        coverflowEffect: {
          rotate: 20,
          stretch: -100,
          depth: 700,
          modifier: 1,
          slideShadows: true,
        },
        //显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        //设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        //自动轮播
        autoplay: {
          delay: 3000,
          //当用户滑动图片后继续自动轮播
          disableOnInteraction: true,
        },
        //开启循环模式
        loop: true,
      },
      oldEventPic: [
      ],
      lightBoxMedia: []
    };
  },
  created() {
    this.tenantConfig = this.$store.getters.tenantInfo;
    this.getPicList()
    this.getVideoList();
  },
  methods: {
    getVideoList() {
      getAction("/teaching/teachingCms/getCmsList", {
        cmsStatus: 1,
        cmsType: 5,
        pageSize: 12,
      }).then((res) => {
        if (res.success) {
          this.videoDataSource = res.result.records;
        }
      });
    },
    getPicList(){
      getAction("/teaching/teachingCms/getCmsList", {
        cmsStatus: 1,
        cmsType: 10,
        pageSize: 10,
      }).then((res) => {
        if (res.success) {
          this.picDataSource = res.result.records;
          this.oldEventPic = this.picDataSource.map(i=>{
            return {
              img: i.cmsCover_url,
              href: "#"
            }
          })
        }
      });
    },
    toVideoDetail(item) {
      this.currentVideo = item;
      this.videoVisible = true;
      getAction("/teaching/teachingCms/getCmsDetail?id=" + item.id)
    },
    toPicDetail(item){
      //使阅读量+1
      getAction("/teaching/teachingCms/getCmsDetail?id=" + item.id)
      let that = this
      let fileNames = []
      if(item.extraFilename){
        fileNames = JSON.parse(item.extraFilename)
        console.log(fileNames);
      }
      if(item.extraFile){
        this.lightBoxMedia = item.extraFile.split(",").map(f=>{
          let fn = ""
          if(f in fileNames){
            fn = fileNames[f]
          }
          return {
            thumb: that.getQiniuUrl(f),
            src: that.getQiniuUrl(f),
            caption: fn
          }
        })
        this.$refs.lightbox.showImage(0)
      }else{
        //this.$message.warning("没有图像")
      }
    },
    getQiniuUrl(text){
      if(!text){
        this.$message.warning("未知的文件")
        return;
      }
      if(text.indexOf(",")>0){
        text = text.substring(0,text.indexOf(","))
      }
      if(text.startsWith("http")){
        return text
      }
      return this.tenantConfig.qiniuDomain + "/" + text;
    },
  },
};
</script>

<style lang="less" scoped>
.video-card {
  .cover {
    width: 100%;
    height: 120px;
    // max-height: 140px;
  }
}
.carousel {
  max-height: 400px;
  img {
    height: 300px;
    width: 500px;
    // width: 100%;
  }
}
.see-more {
  color: #fff;
  text-align: right;
  float: right;
}
.see-more:hover {
  color: #1890ff;
}
.event-pic {
  margin-bottom: 20px;
}
.event-video {
  margin-top: 20px;
  .img-zoom {
    height: 180px;
    border: rgb(192, 192, 192) solid 1px;
    border-radius: 5px;
    .cover {
      height: 100%;
      width: 100%;
    }
  }
}
</style>